import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.25 0h13.5C16.969 0 18 1.031 18 2.25v19.5A2.25 2.25 0 0 1 15.75 24h-4.5v-3.75C11.25 19.031 10.219 18 9 18a2.25 2.25 0 0 0-2.25 2.25V24h-4.5A2.22 2.22 0 0 1 0 21.75V2.25A2.25 2.25 0 0 1 2.25 0M3 11.25v1.5c0 .422.328.75.75.75h1.5c.375 0 .75-.328.75-.75v-1.5c0-.375-.375-.75-.75-.75h-1.5c-.422 0-.75.375-.75.75m5.25-.75c-.422 0-.75.375-.75.75v1.5c0 .422.328.75.75.75h1.5c.375 0 .75-.328.75-.75v-1.5c0-.375-.375-.75-.75-.75zm3.75.75v1.5c0 .422.328.75.75.75h1.5c.375 0 .75-.328.75-.75v-1.5c0-.375-.375-.75-.75-.75h-1.5c-.422 0-.75.375-.75.75M3.75 4.5c-.422 0-.75.375-.75.75v1.5c0 .422.328.75.75.75h1.5c.375 0 .75-.328.75-.75v-1.5c0-.375-.375-.75-.75-.75zm3.75.75v1.5c0 .422.328.75.75.75h1.5c.375 0 .75-.328.75-.75v-1.5c0-.375-.375-.75-.75-.75h-1.5c-.422 0-.75.375-.75.75m5.25-.75c-.422 0-.75.375-.75.75v1.5c0 .422.328.75.75.75h1.5c.375 0 .75-.328.75-.75v-1.5c0-.375-.375-.75-.75-.75z"
    }, null, -1)
  ]))]))
}
export default { render: render }